// import './media.scss';

export { default } from './Media';
export { default as template } from './media.tpl';
